import React, { useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import BatchCustomerstable from "./components/BatchCustomerstable";
import PageHeader from "../../../shared/components/PageHeader";
import { getCustomers } from "../actions/customers.actions";
//get the actions from card request action.
import { retryFailed, sendSuccessCards, getCardRequest, resetCardRequest } from "../../CardRequests/actions/cardrequests.actions";

const BatchCustomersList = ({ dispatch, customers, match, location, retryRequest, sendSucessfulCardOnly, cardRequest, history, ...props }) => {
    const [showRetryButton, setShowRetryButton] = useState(false);
    const [showSendSucesssFulButton, setShowSendSucesssFulButton] = useState(false);
    const [showResendButton, setShowResendButton] = useState(false);
    const fetchRequests = (requestParams) => {
        dispatch(getCustomers(requestParams, requestParams && requestParams.batchId));
    };

    const resetCardStatus = () => {
        dispatch(resetCardRequest());
    };
    useEffect(() => {
        return () => {
            setShowRetryButton(false);
            setShowSendSucesssFulButton(false);
            setShowResendButton(false);
            resetCardStatus();
        };
    }, []);

    useEffect(() => {
        dispatch(getCustomers({ page: 1, pageSize: 10 }, match.params.id));
        dispatch(getCardRequest(match.params.id));
    }, [dispatch, match.params.id, location]);

    useEffect(() => {
   

        if (retryRequest && retryRequest.success) {
           
            try {
                dispatch(getCardRequest(match.params.id));
            } catch (err) {
                console.error(err);
            }
        }
    }, [retryRequest, dispatch, match.params.id]);

    useEffect(() => {
       

        if (cardRequest && cardRequest.response) {
     
            if (cardRequest.success) {
             
                if ((cardRequest.response.autoUploadStatus === "REQUEST_PRODUCTION_FAILED" && cardRequest.response.status === "FAILED") || (cardRequest.response.autoUploadStatus === null && cardRequest.response.status === "PENDING")) {
                    setShowRetryButton(true);
                    setShowResendButton(false);
                  
                }
                if (cardRequest.response.autoUploadStatus === "REQUEST_PRODUCTION_FAILED" && cardRequest.response.status === "FAILED") {
                    setShowSendSucesssFulButton(true);
                }
                if ((cardRequest.response.autoUploadStatus === "REQUEST_PERSONALIZATION_FAILED" || cardRequest.response.autoUploadStatus === "REQUEST_VALIDATION_FAILED") && cardRequest.response.status === "FAILED") {
                    setShowRetryButton(false);
                    setShowResendButton(true);
                    setShowSendSucesssFulButton(false);
                   
                }
            }
        }
    }, [cardRequest && cardRequest.success]);

    function retryBulk() {
    
        try {
            if (customers && customers.request && customers.request.batchId) {
              
                if (showResendButton) {
                    
                    dispatch(retryFailed(customers.request.batchId, "resend", history));
                } else {
                    dispatch(retryFailed(customers.request.batchId, "retry", history));
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    function sendSuccesfulCardsActions() {
        try {
            if (customers && customers.request && customers.request.batchId) {
               

                dispatch(sendSuccessCards(customers.request.batchId, "complete"));
            }
        } catch (err) {
            console.error(err);
        }
    }
    return (
        <Container>
            <PageHeader header="Manage Batch Customers" subheader="Manage prepaid card customers" />
            <Row>
                <BatchCustomerstable
                    batchId={match.params.id}
                    dataState={customers}
                    fetchData={fetchRequests}
                    retryRequest={retryRequest}
                    sendSucessfulCardOnly={sendSucessfulCardOnly}
                    retryBulk={retryBulk}
                    completedBatch={sendSuccesfulCardsActions}
                    cardRequest={cardRequest}
                    showRetryButton={showRetryButton}
                    showSendSucesssFulButton={showSendSucesssFulButton}
                    showResendButton={showResendButton}
                />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    customers: state.getCustomers,
    retryRequest: state.retryCardRequestReducer,
    sendSucessfulCardOnly: state.sendSuccessCardsReducer,
    cardRequest: state.getCardRequest,
}))(withRouter(BatchCustomersList));
//retryRequest.loading
